var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCashtabMsg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 102h80c7.7188 0 14-6.2812 14-14v-48c0-7.7188-6.2812-14-14-14h-80c-7.7188 0-14 6.2812-14 14v48c0 7.7188 6.2812 14 14 14zm86-14c0 3.3086-2.6914 6-6 6h-80c-3.3086 0-6-2.6914-6-6v-48c0-0.15625 0.035156-0.30078 0.046875-0.45312l38.43 31.371c2.1797 1.7812 4.8516 2.6719 7.5195 2.6719 2.6719 0 5.3398-0.89062 7.5195-2.6719l38.43-31.371c0.011719 0.14844 0.046876 0.30078 0.046876 0.45312v48zm-6-54c0.03125 0 0.058594 0.011719 0.089844 0.011719l-37.625 30.711c-1.4258 1.1641-3.5 1.1641-4.9258 0l-37.625-30.711c0.03125 0 0.058594-0.011719 0.089844-0.011719h80z",
    fill: "#00abe6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCashtabMsg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cashtab-msg.21f951db87ed91ca27a2e42f18e5e55e.svg";